import React from 'react';
import './App.css';
import { MapComponent } from './components/MapComponent';
import { FeedComponent } from './components/FeedComponent';

const App: React.FC = () => {
  return (
    <div className="App">
      <img
        src={`${process.env.PUBLIC_URL}/images/wrangler-logo.png`}
        className="logo"
      />
      <div className="content">
        <MapComponent />
        <FeedComponent />
      </div>
    </div>
  );
}

export default App;
